import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  static targets = ['tooltip']
  static values = {
    startDisabled: { type: Boolean, default: false },
    html: { type: Boolean, default: false }
  }

  connect() {
    if (!this.hasTooltipTarget) {
      return
    }

    const tooltipElement = this.tooltipTarget
    const parentDialog = this.tooltipTarget.closest('dialog')
    const container = parentDialog ? `#${parentDialog.getAttribute('id')}` : 'body'

    if (tooltipElement.getAttribute('data-bs-title')) {
      const allowHtml = this.htmlValue || tooltipElement.dataset.html === 'true'
      const tooltip = new Tooltip(tooltipElement, { html: allowHtml, container })

      if (this.startDisabledValue) tooltip.disable()
    }
    this.tooltipTarget.addEventListener('shown.bs.tooltip', this.handleKeyBoardInteraction.bind(this))
    this.tooltipTarget.addEventListener('enabled.bs.tooltip', this.toggleBsTooltip.bind(this))
  }

  handleKeyBoardInteraction() {
    const tooltip = Tooltip.getInstance(this.tooltipTarget)

    this.tooltipTarget.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        tooltip.hide()
      }
    })
  }

  toggleBsTooltip(event) {
    if (!this.hasTooltipTarget) {
      return
    }

    const tooltip = Tooltip.getInstance(this.tooltipTarget)

    if (event.detail.enable) {
      tooltip.enable()
    } else {
      tooltip.disable()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  disconnect() {
    if (!this.hasTooltipTarget) {
      return
    }
    // get rid of lingering tooltips when using turbo streams
    const tooltip = Tooltip.getInstance(this.tooltipTarget)
    if (tooltip !== null) tooltip.dispose()
    this.tooltipTarget.removeEventListener('keydown', this.handleKeyBoardInteraction.bind(this))
  }
}
